var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "one-configurator-test-container" },
    [
      _c("div", { staticClass: "one-configurator-buttons" }, [
        _c(
          "button",
          {
            staticClass: "rb-btn rb-btn--black",
            on: {
              click: function ($event) {
                return _vm.openPayOverTimePanel()
              },
            },
          },
          [_vm._v("\n      Open Klarna/Afterpay Modal\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "rb-btn rb-btn--red",
            on: {
              click: function ($event) {
                return _vm.openLensDetailsPanel()
              },
            },
          },
          [_vm._v("\n      Open Lens Details Panel\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("modal-portal", { staticClass: "modal-wrapper--footer" }),
      _vm._v(" "),
      _c("rb-lens-details-panel"),
      _vm._v(" "),
      _c(
        "rb-panel",
        { attrs: { "ui-store-key": "klarnaAfterpayMobile" } },
        [_c("rb-pdp-klarna-afterpay-panel")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }